// LoadingSpinner.jsx
import ReactDOM from 'react-dom';
import loadingSpinner from '../assets/loading.gif';

export const LoadingSpinner = ({ loading }) => {
  if (!loading) return null;

  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 w-screen h-screen z-[999999] flex flex-col items-center justify-center text-center bg-[#ffffff59]">
      <img src={loadingSpinner} alt="Loading..." />
    </div>,
    document.body
  );
};